<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'

import { PLAN_TYPES } from '@/api/interfaces'
import { useEditorStore } from '@/stores/Editor'
import { useAccountStore } from '@/stores/Account'

import BaseRadioGroup, { type RadioItem } from '@/components/common/BaseRadioGroup.vue'

const editorStore = useEditorStore()
const accountStore = useAccountStore()
const { t } = useTranslate('local')

const items: RadioItem[] = [
  {
    label: t.value(`EditorHeroSettings.style.center`),
    value: 'center',
    imageUrl: '/src/assets/images/editor/hero-style-center.webp',
  },
  {
    label: t.value(`EditorHeroSettings.style.alignLeft`),
    value: 'align-left',
    imageUrl: '/src/assets/images/editor/hero-style-align-left.webp',
    planType: PLAN_TYPES.GROWTH,
    disabled: accountStore.hasStarterPlan,
  },
  {
    label: t.value(`EditorHeroSettings.style.sideBySide`),
    value: 'side-by-side',
    imageUrl: '/src/assets/images/editor/hero-style-side-by-side.webp',
    planType: PLAN_TYPES.GROWTH,
    disabled: accountStore.hasStarterPlan,
  },
]
</script>

<template>
  <div class="mb-5">
    <BaseRadioGroup
      v-model="editorStore.editor.hero.style"
      :items="items"
      :disabled="editorStore.publishLoading"
    />
  </div>
</template>

<style lang="scss" scoped></style>
